import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleConversationBlock.module.scss';
import { clearAllTagsFromString } from '../../../utilities';

/**
 * Conversation block contains messages (left - received, right - sent) and a spacer.
 */
const ArticleConversationBlock = (props) => {
  const { messages, messagesQA } = props;

  // using index as a key, needs to change if generated elements become dynamic
  const formMessage = (message, index) => {
    const { type, text } = message;
    switch (type) {
      case 'space':
        return <div key={index} className={style.space} />;
      case 'left':
        return (
          <div key={index} className={style.messageLeft}>
            {text}
          </div>
        );
      case 'right':
      default:
        return (
          <div key={index} className={style.messageRight}>
            {text}
          </div>
        );
    }
  };

  let messagesToDisplay = messages;

  if (messagesQA) {
    messagesToDisplay = [];
    for (let i = 0; i < messagesQA?.length; i += 1) {
      messagesToDisplay.push({
        type: 'right',
        text: clearAllTagsFromString(messagesQA[i]?.conversationQuestion),
      });
      messagesToDisplay.push({
        type: 'left',
        text: clearAllTagsFromString(messagesQA[i]?.conversationAnswer),
      });
      messagesToDisplay.push({ type: 'space' });
    }
  }

  return (
    <div className={style.wrapper}>
      {messagesToDisplay?.map((message, index) => formMessage(message, index))}
    </div>
  );
};

ArticleConversationBlock.defaultProps = {
  messages: [],
  messagesQA: [],
};

ArticleConversationBlock.propTypes = {
  /** An array of message objects which follow the structure: {type, text} */
  messages: PropTypes.array,
  messagesQA: PropTypes.array,
};

export default ArticleConversationBlock;
